<div class="separador text-center">
  <h2 class="titulo ml-5">Nuestra Asociación tiene a su cargo dos pequeños hogares convivenciales, en dos
    casas.</h2>
</div>
